import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { FaUserTimes } from "react-icons/fa";
import { UseHrApp } from "../../utils/context";
import axios from "axios";
import PositionedSnackbar from "../snackbar";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  p: 4,
};

export default function DeleteModal({ firstname, lastname, id }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    GetEmployees,
    token,
    text,
    show,
    severity,
    settext,
    setshow,
    setseverity,
  } = UseHrApp();

  async function Fire() {
    try {
      const res = await axios({
        url: `https://hr-app-api.onrender.com/employees/left?id=${id}`,
        method: "Delete",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res?.data?.status) {
        setseverity("success");
        setshow(true);
        settext(
          `Employee- ${firstname} ${lastname} has been deleted successfully  `
        );
        GetEmployees();
      }
    } catch (error) {
      console.error("Error deleting employee:", error);
    }
  }

  return (
    <div>
      <button
        className=" bord w-max p-[2px] flex items-center justify-center bg-black "
        onClick={handleOpen}
      >
        <FaUserTimes color="white" />{" "}
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <p> Are you sure you would like to delete?</p>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div className=" flex gap-3 mt-[1em] ">
              <button
                className=" w-full p-2 bg-[#BDF3C0] flex justify-center items-center"
                onClick={() => {
                  Fire();
                  handleClose();
                }}
              >
                Yes
              </button>
              <button
                className=" w-full p-2 bg-[#F9C0C0]  flex justify-center items-center"
                onClick={handleClose}
              >
                No
              </button>
            </div>
          </Typography>
        </Box>
      </Modal>
      <PositionedSnackbar
        value={show}
        setshow={setshow}
        text={text}
        severity={severity}
      />
    </div>
  );
}
